import React from "react";
import { Button as MuiButton, CircularProgress } from "@material-ui/core";

interface ButtonProps {
  color?:
    | "primary"
    | "secondary"
    | "dark-pink"
    | "light-green"
    | "upload"
    | "create-video"
    | "rounded"
    | "transparent"
    | "social"
    | "none";
  children: React.ReactNode;
  className?: string;
  rounded?: boolean;
  variant?: "contained" | "outlined" | "text";
  disabled?: boolean;
  loading?: Boolean;
  loaderSize?: number;
  [key: string]: any;
}

const OUTLINE_COLORS = new Set([
  "secondary",
  "rounded",
  "transparent",
  "upload",
]);

const Button = ({
  color = "primary",
  children,
  className,
  loading,
  loaderSize,
  rounded,
  disabled,
  variant,
  ...props
}: ButtonProps) => {
  const isText = variant === "text";
  const isSocial = color === "social";
  const isLightGreen = color === "light-green";
  const isOutline =
    !isText &&
    !isSocial &&
    !isLightGreen &&
    (variant === "outlined" ||
      rounded ||
      color === "none" ||
      OUTLINE_COLORS.has(color || ""));
  const resolvedVariant = isText
    ? "text"
    : isOutline || isSocial
    ? "outlined"
    : "contained";
  const variantClass = isText
    ? "btn-text"
    : isSocial
    ? "btn-social"
    : isLightGreen
    ? "btn-light-green"
    : isOutline
    ? "btn-outline"
    : "btn-primary";

  return (
    <MuiButton
      color="primary"
      variant={resolvedVariant}
      className={`btn ${variantClass} btn-${color} ${className || ""} ${
        rounded ? "btn-rounded" : ""
      }`}
      disabled={disabled || loading === true ? true : false}
      {...props}
    >
      {loading === true && (
        <CircularProgress size={loaderSize} className="p-absolute" />
      )}{" "}
      {children}
    </MuiButton>
  );
};

Button.defaultProps = {
  color: "primary",
  className: "",
  loading: false,
  loaderSize: 18,
};

export default Button;
